import API from '../api/api'

const SYNC_SMS_NOTIFICATIONS_PENDING = 'SYNC_SMS_NOTIFICATIONS_PENDING'
const SYNC_SMS_NOTIFICATIONS_PROGRESS = 'SYNC_SMS_NOTIFICATIONS_PROGRESS'
const SYNC_SMS_NOTIFICATIONS_RESPONSE = 'SYNC_SMS_NOTIFICATIONS_RESPONSE'

const SAVE_SMS_NOTIFICATIONS_PENDING = 'SAVE_SMS_NOTIFICATIONS_PENDING'
const SAVE_SMS_NOTIFICATIONS_PROGRESS = 'SAVE_SMS_NOTIFICATIONS_PROGRESS'
const SAVE_SMS_NOTIFICATIONS_RESPONSE = 'SAVE_SMS_NOTIFICATIONS_RESPONSE'

const EXPORT_SMS_NOTIFICATIONS_PENDING = 'EXPORT_SMS_NOTIFICATIONS_PENDING'
const EXPORT_SMS_NOTIFICATIONS_PROGRESS = 'EXPORT_SMS_NOTIFICATIONS_PROGRESS'
const EXPORT_SMS_NOTIFICATIONS_RESPONSE = 'EXPORT_SMS_NOTIFICATIONS_RESPONSE'

const IMPORT_SMS_NOTIFICATIONS_PENDING = 'IMPORT_SMS_NOTIFICATIONS_PENDING'
const IMPORT_SMS_NOTIFICATIONS_PROGRESS = 'IMPORT_SMS_NOTIFICATIONS_PROGRESS'
const IMPORT_SMS_NOTIFICATIONS_RESPONSE = 'IMPORT_SMS_NOTIFICATIONS_RESPONSE'
const RESET_ERRORS = 'RESET_ERRORS'

const initialState = {
  sync_sms_notifications_pending: true,
  save_sms_notifications_pending: false,
  export_sms_notifications_pending: false,
  export_po_download_url: null,
  export_csv_download_url: null,
  import_sms_notifications_pending: false,
  imported_entries: 0,
  error: false,
  progress: 0,
  sms_notifications: [],
}

// REDUCER
export default (state = initialState, action) => {
  switch(action.type) {
    case RESET_ERRORS: {
      return {
        ...state,
        error: false,
      }
    }

    case SYNC_SMS_NOTIFICATIONS_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_sms_notifications_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        error: false,
      }
    }
    case SYNC_SMS_NOTIFICATIONS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SYNC_SMS_NOTIFICATIONS_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          sync_sms_notifications_pending: false,
          error: false,
          sms_notifications: action.response.notifications.slice()
        }
      } else {
        return {
          ...state,
          sync_sms_notifications_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 0,
          },
        }
      }
    }

    case SAVE_SMS_NOTIFICATIONS_PENDING: {
      return {
        ...state,
        progress: 0,
        save_sms_notifications_pending: true,
        error: false,
      }
    }
    case SAVE_SMS_NOTIFICATIONS_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    case SAVE_SMS_NOTIFICATIONS_RESPONSE: {
      let error = false;
      let newNotifications = state.sms_notifications.slice();
      action.response.forEach((response, i) => {
        if(response.success !== true) {
          error = {
            message: action.response,
            action: action.action,
          };
          let newNotification = newNotifications.find(x => x.id == action.items[i].id)
          newNotification.target = action.items[i].body
        } else {
          let newNotification = newNotifications.find(x => x.id == response.notification.id)
          newNotification.progress = response.notification.progress
          newNotification.source = response.notification.source
          newNotification.target = response.notification.target
        }
      })
      return {
        ...state,
        sms_notifications: newNotifications,
        save_sms_notifications_pending: false,
        error: error
      }
    }

    case EXPORT_SMS_NOTIFICATIONS_PENDING: {
      return {
        ...state,
        progress: 0,
        export_sms_notifications_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        error: false,
      }
    }
    case EXPORT_SMS_NOTIFICATIONS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case EXPORT_SMS_NOTIFICATIONS_RESPONSE: {
      if(action.response.success == true) {
        return {
          ...state,
          progress: 100,
          export_sms_notifications_pending: false,
          export_po_download_url: action.response.po_download_url,
          export_csv_download_url: action.response.csv_download_url
        }
      } else {
        return {
          ...state,
          progress: 100,
          export_sms_notifications_pending: false
        }
      }
    }
    case IMPORT_SMS_NOTIFICATIONS_PENDING: {
      return {
        ...state,
        progress: 0,
        import_sms_notifications_pending: true,
        imported_entries: 0,
        error: false,
      }
    }
    case IMPORT_SMS_NOTIFICATIONS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case IMPORT_SMS_NOTIFICATIONS_RESPONSE: {
      let isOk = true;
      let importedEntries = 0;
      action.response.forEach(response => {
        if(response.success !== true) {
          isOk = false
        } else {
          importedEntries += response.imported_entries
        }
      })

      if(isOk == true) {
        return {
          ...state,
          progress: 100,
          import_sms_notifications_pending: false,
          imported_entries: importedEntries
        }
      } else {
        return {
          ...state,
          progress: 100,
          import_sms_notifications_pending: false,
          imported_entries: importedEntries
        }
      }
    }
    default:
      return state
  }
}

// ACTIONS
export const resetErrors = () => {
  return dispatch => {
    dispatch({
      type: RESET_ERRORS
    });
  }
}

export const syncSMSNotifications = (languageId, progress) => { 
  return dispatch => {
    dispatch({
      type: SYNC_SMS_NOTIFICATIONS_PENDING
    })

    API.syncSMSNotifications(
      languageId,
      progress => {
        dispatch({
          type: SYNC_SMS_NOTIFICATIONS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: SYNC_SMS_NOTIFICATIONS_RESPONSE,
          response: response,
          action: () => syncSMSNotifications(languageId, progress)
        })
      }
    )
  }
}

export const saveSMSNotifications = (language, items) => {  
  return dispatch => {
    dispatch({
      type: SAVE_SMS_NOTIFICATIONS_PENDING
    })

    API.saveSMSNotifications(
      language,
      items,
      progress => {
        dispatch({
          type: SAVE_SMS_NOTIFICATIONS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: SAVE_SMS_NOTIFICATIONS_RESPONSE,
          response: response,
          items: items,
          action: () => saveSMSNotifications(language, items)
        })
      })
  }
}

export const exportSMSNotifications = (language) => {
  return dispatch => {
    dispatch({
      type: EXPORT_SMS_NOTIFICATIONS_PENDING
    })

    API.exportSMSNotifications(
      language,
      progress => {
        dispatch({
          type: EXPORT_SMS_NOTIFICATIONS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: EXPORT_SMS_NOTIFICATIONS_RESPONSE,
          response: response,
          action: () => exportSMSNotifications(language)
        }
      )
    })
  }
}

export const importSMSNotifications = (file, fileType, language) => {
  return dispatch => {
    dispatch({
      type: IMPORT_SMS_NOTIFICATIONS_PENDING
    })

    API.importSMSNotifications(
      file,
      fileType,
      language,
      progress => {
        dispatch({
          type: IMPORT_SMS_NOTIFICATIONS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: IMPORT_SMS_NOTIFICATIONS_RESPONSE,
          response: response,
          action: () => importSMSNotifications(file, fileType, language)
        }
      )
    })
  }
}